module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal__content pr100 pl100 pb40"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row flex--align-vertical"
  }, [_c('div', {
    staticClass: "col-md-4 mb20 pr45"
  }, [_c('label', {
    attrs: {
      "for": "user-profile-image"
    }
  }, [(_vm.user.avatarKey) ? _c('img', {
    staticClass: "img-circle mr15",
    attrs: {
      "src": '/serve/s/' + _vm.user.avatarKey + '?w=240&h=240',
      "alt": "user.name"
    }
  }) : _c('img', {
    staticClass: "img-circle mr15",
    attrs: {
      "src": "/static/images/user/user-avatar-demo-big@2x.png",
      "alt": "user.name"
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "user-profile-image",
      "accept": "image/*",
      "hidden": ""
    },
    on: {
      "change": function($event) {
        return _vm.onUserAvatarUpload($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-6 form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.surname),
      expression: "user.surname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "surname",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.user.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "surname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.user.role !== 'admin' && _vm.user.role !== 'customer') ? _c('div', {
    staticClass: "col-md-6 form-row form-row--select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role),
      expression: "user.role"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "user-role",
      "id": "user-role"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.userRoles), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.name))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.passwordPlainText),
      expression: "user.passwordPlainText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "Password",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.user.passwordPlainText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "passwordPlainText", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 form-row"
  }, [_c('div', {
    staticClass: "form-row__rate"
  }, [_c('label', {
    attrs: {
      "for": "hour-rate"
    }
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.hourRate),
      expression: "user.hourRate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "hour-rate"
    },
    domProps: {
      "value": (_vm.user.hourRate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "hourRate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "hour-rate"
    }
  }, [_vm._v("per hour")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt20"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-4"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    attrs: {
      "disabled": _vm.user.passwordPlainText === null
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Add")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-4"
  }, [_c('h3', {
    staticClass: "text-regular mb40 ml20"
  }, [_vm._v("Add new user")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8084d3ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/users/modals/AddUserModal.vue
// module id = 446
// module chunks = 2